const Hero = () => {
  return (
    <section className="relative w-full">
      {/* Banner */}
      <img
        src="/images/banner1.webp"
        alt="Herbal Banner"
        loading="lazy"
        className="w-full h-auto object-contain"
      />

      {/* FSSAI Badge */}
      <div
        className="
          absolute
          bottom-4
          left-4
          md:bottom-8
          md:left-8
          bg-white/90
          backdrop-blur-sm
          px-3
          py-2
          rounded-full
          flex
          items-center
          gap-2
          shadow-lg
        "
      >
      

        <p className="text-xs md:text-sm font-semibold text-green-700">
          FSSAI Certified 
        </p>
      </div>
    </section>
  );
};

export default Hero;